var $50f1093a6d23d116$exports = {};
$50f1093a6d23d116$exports = {
    "decrease": (args)=>`\u{62E}\u{641}\u{636} ${args.fieldLabel}`,
    "increase": (args)=>`\u{632}\u{64A}\u{627}\u{62F}\u{629} ${args.fieldLabel}`,
    "numberField": `\u{62D}\u{642}\u{644} \u{631}\u{642}\u{645}\u{64A}`
};


export {$50f1093a6d23d116$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
